function filterByOfferCategory(category, button) {
    var items = document.getElementsByClassName('offers-filter-component-item');

    for (var i = 0; i < items.length; i++) {

        var itemCategories = items[i].getAttribute('data-categories').split(',');

        if (category === 'All' || itemCategories.includes(category)) {
            items[i].style.display = '';
        } else {
            items[i].style.display = 'none';
        }
    }

    // Remove active class from all buttons
    var buttons = document.getElementById('offers-filter-buttons').getElementsByTagName('button');
    for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('active');
    }

    // Add active class to the clicked button
    button.classList.add('active');
}

function filterByOfferCategoryMobile(category) {
    var value = category.value;

    var items = document.getElementsByClassName('offers-filter-component-item');

    for (var i = 0; i < items.length; i++) {

        var itemCategories = items[i].getAttribute('data-categories').split(',');

        if (value === 'All' || itemCategories.includes(value)) {
            items[i].style.display = '';
        } else {
            items[i].style.display = 'none';
        }
    }  
}

function filterBySpa(category, button) {
    var items = document.getElementsByClassName('spa-filter-component-item');

    for (var i = 0; i < items.length; i++) {

        var itemCategories = items[i].getAttribute('data-categories').split(',');

        if (category === 'All' || itemCategories.includes(category)) {
            items[i].style.display = '';
        } else {
            items[i].style.display = 'none';
        }
    }

    // Remove active class from all buttons
    var buttons = document.getElementById('spa-filter-buttons').getElementsByTagName('button');
    for (var i = 0; i < buttons.length; i++) {
        buttons[i].classList.remove('active');
    }

    // Add active class to the clicked button
    button.classList.add('active');
}

function filterBySpaMobile(category) {
    var value = category.value;

    var items = document.getElementsByClassName('spa-filter-component-item');

    for (var i = 0; i < items.length; i++) {

        var itemCategories = items[i].getAttribute('data-categories').split(',');

        if (value === 'All' || itemCategories.includes(value)) {
            items[i].style.display = '';
        } else {
            items[i].style.display = 'none';
        }
    }
}

function filterEventsByHotel(selectObj) {
    var hotel = selectObj.value; 

    var items = document.getElementsByClassName('events-filter-component-item');

    for (var i = 0; i < items.length; i++) {

        var itemCategories = items[i].getAttribute('data-categories').split(',');

        if (hotel === 'All' || itemCategories.includes(hotel)) {
            items[i].style.display = '';
        } else {
            items[i].style.display = 'none';
        }
    }
}

function filterExperiencesByHotel(selectObj) {
    var hotel = selectObj.value; 

    var items = document.getElementsByClassName('experiences-filter-component-item');

    for (var i = 0; i < items.length; i++) {

        var itemCategories = items[i].getAttribute('data-categories').split(',');

        if (hotel === 'All' || itemCategories.includes(hotel)) {
            items[i].style.display = '';
        } else {
            items[i].style.display = 'none';
        }
    }
}

function filterByBlogCategory(category, button) {
    var items = document.getElementsByClassName('blog-filter-component-item');

    var hotelValue = document.getElementById("blog-filter-dropdown").value;

    var monthValue = document.getElementById("blog-filter-dropdown-2").value;
    //var monthValue = "All";

    RemoveClassName("no-filter");

    if (hotelValue !== 'All') {
        for (var i = 0; i < items.length; i++) {

            var itemCategories = items[i].getAttribute('data-categories').split(',');

            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if (category === 'All' || itemCategories.includes(category)) {
                if (itemHotelCategories.includes(hotelValue) && (monthValue === 'All' || itemMonth === monthValue)) {
                    items[i].style.display = '';
                } else {
                    items[i].style.display = 'none';
                }
            } else {
                items[i].style.display = 'none';
            }
        }
    } else {
        for (var i = 0; i < items.length; i++) {

            var itemCategories = items[i].getAttribute('data-categories').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if ((category === 'All' || itemCategories.includes(category)) && (monthValue === 'All' || itemMonth === monthValue)) {
                items[i].style.display = '';
            } else {
                items[i].style.display = 'none';
            }
        }
    }

    if (button != null) {

        // Remove active class from all buttons
        var buttons = document.getElementById('blog-filter-buttons').getElementsByTagName('button');
        for (var i = 0; i < buttons.length; i++) {
            buttons[i].classList.remove('active');
        }

        // Add active class to the clicked button
        button.classList.add('active');
    }
}

function filterBlogByHotel(selectObj) {
    var hotel = selectObj.value; 

    var category = document.querySelector(".blog-filter-tab.active").value;

    var monthValue = document.getElementById("blog-filter-dropdown-2").value;
    //var monthValue = "All";

    var items = document.getElementsByClassName('blog-filter-component-item');

    RemoveClassName("no-filter");

    if (category !== 'All') {
        for (var i = 0; i < items.length; i++) {

            var itemCategories = items[i].getAttribute('data-categories').split(',');

            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if (hotel === 'All' || itemHotelCategories.includes(hotel)) {
                if (itemCategories.includes(category) && (monthValue === 'All' || itemMonth === monthValue)) {
                    items[i].style.display = '';
                } else {
                    items[i].style.display = 'none';
                }
            } else {
                items[i].style.display = 'none';
            }
        }
    } else {
        for (var i = 0; i < items.length; i++) {

            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if ((hotel === 'All' || itemHotelCategories.includes(hotel)) && (monthValue === 'All' || itemMonth === monthValue)) {
                items[i].style.display = '';
            } else {
                items[i].style.display = 'none';
            }
        }
    }
    
}

function filterBlogByMonth(selectObj) {
    var month = selectObj.value; 

    var hotelValue = document.getElementById("blog-filter-dropdown").value;

    var category = document.querySelector(".blog-filter-tab.active").value;

    var items = document.getElementsByClassName('blog-filter-component-item');

    RemoveClassName("no-filter");

    if (category !== 'All') {
        for (var i = 0; i < items.length; i++) {

            var itemCategories = items[i].getAttribute('data-categories').split(',');

            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if (month === 'All' || itemMonth === month) {
                if (itemCategories.includes(category) && (hotelValue === 'All' || itemHotelCategories.includes(hotelValue))) {
                    items[i].style.display = '';
                } else {
                    items[i].style.display = 'none';
                }
            } else {
                items[i].style.display = 'none';
            }
        }
    } else {
        for (var i = 0; i < items.length; i++) {
            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if ((hotelValue === 'All' || itemHotelCategories.includes(hotelValue)) && (month === 'All' || itemMonth === month)) {
                items[i].style.display = '';
            } else {
                items[i].style.display = 'none';
            }
        }
    }
    
}

function filterByBlogCategoryMobile(selectObj) {
    var category = selectObj.value;

    var hotelValue = document.getElementById("blog-filter-dropdown-mobile").value;

    var monthValue = document.getElementById("blog-filter-dropdown-mobile-3").value;

    var items = document.getElementsByClassName('blog-filter-component-item');

    RemoveClassName("no-filter");

    if (hotelValue !== 'All') {
        for (var i = 0; i < items.length; i++) {

            var itemCategories = items[i].getAttribute('data-categories').split(',');

            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if (category === 'All' || itemCategories.includes(category)) {
                if (itemHotelCategories.includes(hotelValue) && (monthValue === 'All' || itemMonth === monthValue)) {
                    items[i].style.display = '';
                } else {
                    items[i].style.display = 'none';
                }
            } else {
                items[i].style.display = 'none';
            }
        }
    } else {
        for (var i = 0; i < items.length; i++) {

            var itemCategories = items[i].getAttribute('data-categories').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if ((category === 'All' || itemCategories.includes(category)) && (monthValue === 'All' || itemMonth === monthValue)) {
                items[i].style.display = '';
            } else {
                items[i].style.display = 'none';
            }
        }
    }
}

function filterBlogByHotelMobile(selectObj) {
    var hotel = selectObj.value;

    var category = document.getElementById("blog-filter-dropdown-mobile-2").value;

    var monthValue = document.getElementById("blog-filter-dropdown-mobile-3").value;

    var items = document.getElementsByClassName('blog-filter-component-item');

    RemoveClassName("no-filter");

    if (category !== 'All') {
        for (var i = 0; i < items.length; i++) {

            var itemCategories = items[i].getAttribute('data-categories').split(',');

            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if (hotel === 'All' || itemHotelCategories.includes(hotel)) {
                if (itemCategories.includes(category) && (monthValue === 'All' || itemMonth === monthValue)) {
                    items[i].style.display = '';
                } else {
                    items[i].style.display = 'none';
                }
            } else {
                items[i].style.display = 'none';
            }
        }
    } else {
        for (var i = 0; i < items.length; i++) {

            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if ((hotel === 'All' || itemHotelCategories.includes(hotel)) && (monthValue === 'All' || itemMonth === monthValue)) {
                items[i].style.display = '';
            } else {
                items[i].style.display = 'none';
            }
        }
    }

}

function filterBlogByMonthMobile(selectObj) {
    var month = selectObj.value;

    var hotelValue = document.getElementById("blog-filter-dropdown-mobile").value;

    var category = document.getElementById("blog-filter-dropdown-mobile-2").value;

    var items = document.getElementsByClassName('blog-filter-component-item');

    RemoveClassName("no-filter");

    if (category !== 'All') {
        for (var i = 0; i < items.length; i++) {

            var itemCategories = items[i].getAttribute('data-categories').split(',');

            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if (month === 'All' || itemMonth === month) {
                if (itemCategories.includes(category) && (hotelValue === 'All' || itemHotelCategories.includes(hotelValue))) {
                    items[i].style.display = '';
                } else {
                    items[i].style.display = 'none';
                }
            } else {
                items[i].style.display = 'none';
            }
        }
    } else {
        for (var i = 0; i < items.length; i++) {
            var itemHotelCategories = items[i].getAttribute('data-hotels').split(',');

            var itemMonth = items[i].getAttribute('data-month');

            if ((hotelValue === 'All' || itemHotelCategories.includes(hotelValue)) && (month === 'All' || itemMonth === month)) {
                items[i].style.display = '';
            } else {
                items[i].style.display = 'none';
            }
        }
    }

}

var itemsToLoad = 5;
function loadMoreBlogs() {
    itemsToLoad += 5;

    var items = document.getElementsByClassName('blog-filter-component-item');

    if (items != null && items.length) {

        let visibleItems = Array.from(items).filter(item =>
            window.getComputedStyle(item).display !== 'none'
        );
        //console.log(visibleItems);
        //if (visibleItems.length < 5) {

        //    HideLoadMoreBtn(".blog-filter-component button.load-more");
        //}

        if (itemsToLoad - 5 < items.length) {

            var loadedItems = [...items].slice(0, itemsToLoad);

            if (loadedItems != null && loadedItems.length) {

                for (var i = 0; i < loadedItems.length; i++) {

                    if (loadedItems[i].classList.contains("to-be-loaded")) {

                        loadedItems[i].classList.remove("to-be-loaded");
                    }
                }

                if (itemsToLoad >= items.length) {

                    HideLoadMoreBtn(".blog-filter-component button.load-more");
                }

            }
        }
    }
}

function HideLoadMoreBtn(className) {
    var loadMoreBtn = document.querySelector(className);

    if (loadMoreBtn != null) {

        loadMoreBtn.style.display = 'none';
    }
}

function RemoveClassName(className) {

    let items = document.getElementsByClassName(className);

    if (items.length > 0) {

        for (let i = 0; i < items.length; i++) {

            items[i].classList.remove(className);
        }
    }
}

function RearrangeFilteredList(items) {


}